<div class="container" id="spinerLoader" *ngIf="loader">
    <div class="loader">Loading...</div>
</div>

<div class="footerPosition">

    <section class="content-header row">
        <div class="col-sm-12">
            <h1 class="box-title">
                <strong>Messages</strong>
                <span class="ml-3">
                    <span class="text-danger count-badge count-font position-absolute">
                        <span *ngIf="!totalMessageCountLoader">
                            {{totalMessageCount}}
                        </span>
                        <span *ngIf="totalMessageCountLoader">
                            <i class="fa fa-spin fa-spinner text-danger"></i>
                        </span>
                    </span>
                </span>
            </h1>
        </div>
    </section>

    <section class="content">
        <div *ngIf="isFilterVisible" class="row">

            <div class="col-lg-3 col-sm-6 pb-4">
                <div id="trip-id-filter" class="background-white radius-5">
                    <ng-multiselect-dropdown-angular7 id="tripId" (onSelect)="filterGroupChatList()"
                        (onDeSelect)="filterGroupChatList()" placeholder="Trip ID"
                        [data]="getTripIdDataModel.tripIdList" [settings]="getTripIdDataModel.tripIdDropdownSettings"
                        [(ngModel)]="getTripIdDataModel.selectedTripIdList">
                    </ng-multiselect-dropdown-angular7>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 pb-4">
                <div id="customer-filter" class="background-white radius-5">
                    <ng-multiselect-dropdown-angular7 id="customerName" (onSelect)="filterGroupChatList()"
                        (onDeSelect)="filterGroupChatList()" placeholder="Customer"
                        [data]="getCustomerDataModel.customerList"
                        [settings]="getCustomerDataModel.customerDropdownSettings"
                        [(ngModel)]="getCustomerDataModel.selectedCustomerList">
                    </ng-multiselect-dropdown-angular7>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 pb-4">
                <div id="group-name-filter">
                    <input [value]="groupNameFilterText" [(ngModel)]="groupNameFilterText" type="text" name="groupName"
                        id="groupName" class="form-control" placeholder="Filter by Group Name"
                        (keyup)="filterGroupChatList()">
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 pb-4">
                <div id="message-filter">
                    <input type="text" name="message" id="message" class="form-control" placeholder="Filter by Message">
                </div>
            </div>

        </div>

        <div class="row">
            <app-chat-list [sRListGroupList]="filteredSRListGroupList" [accessingFrom]="'page'"
                [internalMemberList]="internalMemberList"
                (totalUnreadMessagesCount)="showTotalUnreadMessageCount($event)"></app-chat-list>
            <app-message-panel [internalMemberList]="internalMemberList"></app-message-panel>
        </div>

    </section>

</div>
